<script setup>
import Teleport from "@/components/Teleport.vue";
import { computed } from "vue";

defineEmits(["close"]);

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  distoryAfterClose: {
    type: Boolean,
    default: false,
  },
  className: {
    type: [Object, Array, String],
  },
  maskStyle: {
    type: String,
    default: "normal",
  },
});

const keep = computed(() => (props.distoryAfterClose ? props.show : true));
</script>

<template>
  <Teleport
    to="body"
    v-if="keep">
    <div
      class="app-modal-container"
      v-show="show">
      <div
        class="modal-mask"
        :class="maskStyle"
        @click="$emit('close')"></div>
      <div
        class="modal-content"
        :class="className"
        v-bind="$attrs">
        <div class="transform-box">
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style lang="less" scoped>
@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  30% {
    opacity: 1;
    transform: scale(1.1);
  }
  50% {
    opacity: 1;
    transform: scale(0.95);
  }
  75% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.app-modal-container {
  > .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    &.normal {
      background-color: rgba(0, 0, 0, 0.7);
    }
    &.top {
      z-index: 9999;
      background-color: rgba(0, 0, 0, 0.7);
    }
    &.radial {
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
    }
    z-index: 999;
  }

  > .modal-content {
    position: fixed;
    min-height: 50px;
    min-width: 50px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    > .transform-box {
      animation: bounceIn 500ms both;
    }
    &.top {
      z-index: 10000;
    }
  }
}
</style>
